/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
    wifi: {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: '<path pid="0" d="M15.384 6.115a.485.485 0 00-.047-.736A12.44 12.44 0 008 3C5.259 3 2.723 3.882.663 5.379a.485.485 0 00-.048.736.52.52 0 00.668.05A11.45 11.45 0 018 4c2.507 0 4.827.802 6.716 2.164.205.148.49.13.668-.049"/><path pid="1" d="M13.229 8.271a.482.482 0 00-.063-.745A9.46 9.46 0 008 6c-1.905 0-3.68.56-5.166 1.526a.48.48 0 00-.063.745.525.525 0 00.652.065A8.46 8.46 0 018 7a8.46 8.46 0 014.576 1.336c.206.132.48.108.653-.065m-2.183 2.183c.226-.226.185-.605-.1-.75A6.5 6.5 0 008 9c-1.06 0-2.062.254-2.946.704-.285.145-.326.524-.1.75l.015.015c.16.16.407.19.611.09A5.5 5.5 0 018 10c.868 0 1.69.201 2.42.56.203.1.45.07.61-.091zM9.06 12.44c.196-.196.198-.52-.04-.66A2 2 0 008 11.5a2 2 0 00-1.02.28c-.238.14-.236.464-.04.66l.706.706a.5.5 0 00.707 0l.707-.707z"/>',
    },
});
